import { render, staticRenderFns } from "./HallHead.vue?vue&type=template&id=2edcdf76&scoped=true&"
import script from "./HallHead.vue?vue&type=script&lang=js&"
export * from "./HallHead.vue?vue&type=script&lang=js&"
import style0 from "./HallHead.vue?vue&type=style&index=0&id=2edcdf76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edcdf76",
  null
  
)

export default component.exports